import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from 'react';
import { InputLabel, Tooltip } from '@mui/material';
import { InfoIcon } from '../../Icons';
import { tooltipLabelStyles as classes } from './tooltipLabelStyles';
import { ClassNames } from '@emotion/react';
/**
 * A component used to display a label with an optional tooltip.
 */
export const TooltipLabel = React.forwardRef(function TooltipLabel({ required, htmlFor, id, disabled, tooltipText, label, color, className, weight }, ref) {
    return (_jsxs("div", { ref: ref, css: classes.labelContainer, className: className, children: [_jsx(InputLabel, { id: id, htmlFor: htmlFor, required: required, disabled: disabled, css: classes.label(color, weight), children: label }), tooltipText ? (_jsx(ClassNames, { children: ({ css }) => (_jsx(Tooltip, { title: tooltipText, classes: { tooltip: css(classes.tooltip) }, children: _jsx("span", { role: 'button', tabIndex: 0, css: classes.tooltipButton, children: _jsx(InfoIcon, { css: classes.tooltipIcon(color) }) }) })) })) : null] }));
});
